import { NotFoundedI18n } from '@/locales/base.message.locales';

export const notFounded: NotFoundedI18n = {
    titles: {
        page_not_exists: 'Oops! The page you were looking for doesn\'t exist.'
    },
    subtitles: {
        wrong_address: 'You may have misstyped the address or the page may have moved.'
    },
    buttons: {
        back_to_home: 'Go to homepage'
    }
}
